import createReducer, { ActionCreatorHelper } from '@hh.ru/redux-create-reducer';
export const CHECK_EXPERIMENT = 'CHECK_EXPERIMENT';
const actionCreator = ActionCreatorHelper();
export const addCheckedExp = actionCreator(CHECK_EXPERIMENT);
export const INITIAL_STATE = {
  checked: [],
  enabled: {}
};
export const experimentsReducer = createReducer(INITIAL_STATE, {
  [CHECK_EXPERIMENT]: (state, {
    payload
  }) => ({
    ...state,
    checked: [...state.checked, payload]
  })
});
//# sourceMappingURL=store.js.map